<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/RHk8YX/tc-custom/9781497682009.jpg?1703877195823" alt="This image is the cover for the book Make Believe"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Make Believe
      </h1>
      <p class="bookDescription body article font2">
        <b>When her best friend’s parents separate, a seventh grader struggles to keep their friendship alive</b><br/><br/> When Carrie and Jill are alone together, they can be anyone in the whole world. Whether they’re pretending to be movie stars, environmental activists, or the leaders of the free world, there is one thing they don’t have to imagine: They are as close as any friends could be. Going into seventh grade, there is a lot that Carrie is afraid of, but she knows Jill will be by her side forever—until, suddenly, she’s not.<br/>  <br/> When Jill’s father announces that he wants a divorce, it puts a distance between the two friends that never used to be there. As Jill’s life falls apart around her, Carrie must find a way to talk to her friend again and save her from a problem that’s anything but make-believe.<br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Susan Beth Pfeffer
      </h2>
      
      <p class="authorDescription body article">Susan Beth Pfeffer wrote her first novel,&#160;<I>Just Morgan</I>, during her last semester at New York University. Since then, she has written over seventy novels for children and young adults, including&#160;<I>Kid Power</I>,&#160;<I>Fantasy Summer</I>, <I>Starring Peter and Leigh</I>, and&#160;<I>The Friendship Pact</I>, as well as the series Sebastian Sisters and Make Me a Star. Pfeffer&rsquo;s books have won ten statewide young reader awards and the Buxtehude Bulle Award.<BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3ceb54b2